unit Auth.Service;

interface

uses
  JS;

type

  TSphinxTokenType = (sttAccess, sttId);

  TAuthService = class
  private
    FAccessPayload: TJSObject;
    FIdPayload: TJSObject;
    function DecodePayload(const AToken: string): string;
    function GetAccessPayloadObject: TJSObject;
    function GetIdPayloadObject: TJSObject;

  public
    function GetAccessToken: string;
    function GetClaimValue(const AName: string; const ATokenType: TSphinxTokenType = sttAccess): string;
    function IsAdministrator: Boolean;
    function IsSuperUser: Boolean;
    function UserId: Integer;
    function UserScope: string;
    function UserFullName: string;
  end;

function AuthService: TAuthService;

implementation

uses
  System.SysUtils,
  MainDataModule,
  SMX.Auth.Shared;

var
  _AuthService: TAuthService;

function AuthService: TAuthService;
begin
  if not Assigned(_AuthService) then
  begin
    _AuthService := TAuthService.Create;
  end;
  Result := _AuthService;
end;

{ TAuthService }

function TAuthService.DecodePayload(const AToken: string): string;
begin
  if Trim(AToken) = '' then
    Exit('');
  Result := '';
{$IFDEF PAS2JS}
  asm
    var Token = AToken.split('.');
    if (Token.length = 3) {
    Result = Token[1];
    Result = atob(Result);
     }
  end;
{$ENDIF}
end;

function TAuthService.GetClaimValue(const AName: string; const ATokenType:
    TSphinxTokenType = sttAccess): string;
var
  Obj: TJSObject;
begin
  Result := '';
  if ATokenType = sttAccess then
     Obj := GetAccessPayloadObject
  else
     Obj := GetIdPayloadObject;

  if Obj.hasOwnProperty(AName) then
    Result := JS.toString(Obj.Properties[AName]);
end;

function TAuthService.GetAccessPayloadObject: TJSObject;
var
  AToken, Payload: string;
begin
  if not Assigned(FAccessPayload) then
  begin
    AToken := GetAccessToken;
    Payload := DecodePayload(AToken);
    FAccessPayload := TJSObject(TJSJSON.parse(Payload));
  end;

  Result := FAccessPayload;
end;

function TAuthService.GetAccessToken: string;
begin
  Result := MainData.SphinxLogin.AuthResult.AccessToken;
end;

function TAuthService.GetIdPayloadObject: TJSObject;
var
  AToken, Payload: string;
begin
  if not Assigned(FIdPayload) then
  begin
    AToken := MainData.SphinxLogin.AuthResult.IdToken;
    Payload := DecodePayload(AToken);
    FIdPayload := TJSObject(TJSJSON.parse(Payload));
  end;

  Result := FIdPayload;

end;

function TAuthService.UserFullName: string;
begin
  Result := GetClaimValue(CLAIM_FULLNAME);
end;

function TAuthService.UserId: Integer;
var
  lValue: string;
begin
  Result := 0;

  lValue := GetClaimValue(CLAIM_APP_USER_ID);
  if lValue = '' then
    lValue := GetClaimValue(CLAIM_USERID);
  if lValue = '' then
    lValue := GetClaimValue(CLAIM_APP_USER_ID, sttId);
  if lValue = '' then
    lValue := GetClaimValue(CLAIM_USERID, sttId);

  if lValue <> '' then
    Result := StrToIntDef(lValue, 0);
end;

function TAuthService.IsAdministrator: Boolean;
var
  lLevel: string;
begin
  lLevel := GetClaimValue(CLAIM_SCOPE);
  Result := (lLevel = SCOPE_ADMIN) or (lLevel = SCOPE_SUPERUSER);
end;

function TAuthService.IsSuperUser: Boolean;
var
  lLevel: string;
begin
  lLevel := GetClaimValue(CLAIM_SCOPE);
  Result := (lLevel = SCOPE_SUPERUSER);
end;

function TAuthService.UserScope: string;
begin
  Result := GetClaimValue(CLAIM_SCOPE);
end;

end.
